import { createFeatureSelector } from '@ngrx/store';

export const dietaryTagsImagesState = createFeatureSelector<OLO.State, OLO.State.DietaryTagImage[]>('dietaryTagsImages');
